import Cookies from 'js-cookie';

let esri_auth;
try {
	esri_auth = JSON.parse(Cookies.get('esri_auth'));
} catch (e) {
	esri_auth = null;
}
const authToken = esri_auth ? esri_auth.token : 'null';

const DataService = {
	createNewCustomer: (url, requestBody) => {
		return fetch(`${url}/customer-services/customer`, {
			method: 'POST',
			mode: 'cors',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				Authorization: authToken,
			},
			body: JSON.stringify(requestBody),
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},

	updateCart: (url, request) => {
		return fetch(`${url}/carts/${request._id}`, {
			method: 'PUT',
			mode: 'cors',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				Authorization: authToken,
			},
			body: JSON.stringify(request),
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},

	locale: (url, countryCode, zone) => {
		let localeUrl = `${url}/locale`;

		if (countryCode) {
			localeUrl += `?country=${countryCode}`;
		} else if (zone) {
			localeUrl += `?zone=${zone}`;
		}

		return fetch(localeUrl, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},

	localizedContent: (url, request) => {
		return fetch(`${url}/shopping-services/store/localized-content`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(request),
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},

	getCart: (url, id) => {
		return fetch(`${url}/carts/${id}`, {
			method: 'GET',
			mode: 'cors',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				Authorization: authToken,
			},
		})
			.then((res) => {
				if (!res.ok && res.status !== 404) throw new Error('error');
				else return res.json();
			})
			.then(
				(result) => result[0],
				(error) => error
			);
	},

	getCountries: (url, languge) => fetch(`${url}/countries?appName=eComm-store&language=${languge}`).then((res) => res.json()),

	getStates: (url, countryCode, languge) => fetch(`${url}/states?appName=eComm-store&country=${countryCode}&language=${languge}`).then((res) => res.json()),

	getUserProfile: (url) => {
		return fetch(`${url}/profile-services/profile`, {
			method: 'GET',
			mode: 'cors',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				Authorization: authToken,
			},
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},

	getCustomerNumbers: (url, requestBody) => {
		return fetch(`${url}/customer-services/customer-master`, {
			method: 'POST',
			mode: 'cors',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				Authorization: authToken,
			},
			body: JSON.stringify(requestBody),
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},

	processShoppingCart: (url, request) => {
		const selectedZone = Cookies.get('selectedZone');
		if (selectedZone && window.location.href.includes('int-store')) {
			request.refererPath = `https://${selectedZone.toLowerCase()}.esri.com`;
		}
		return fetch(`${url}/shopping-cart/process-cart`, {
			method: 'POST',
			mode: 'cors',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				Authorization: authToken,
			},
			body: JSON.stringify(request),
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},

	validateCart: (url, request) => {
		return fetch(`${url}/shopping-cart/validate-cart`, {
			method: 'POST',
			mode: 'cors',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				Authorization: authToken,
			},
			body: JSON.stringify(request),
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},

	getPrice: (url, request, zone, currency, distributorNumber) => {
		return fetch(`${url}/product-management/price/${zone}/${currency}?distributorNumber=${distributorNumber}`, {
			method: 'POST',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(request),
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},

	getRenewalConfig: (url, zone, renewalType) => {
		return fetch(`${url}/renewal-services/config?zone=${zone}&renewalType=${renewalType}`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},

	verifyAddress: (url, requestBody) => {
		return fetch(`${url}/checkout-services/verify-address`, {
			method: 'POST',
			mode: 'cors',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				Authorization: authToken,
			},
			body: JSON.stringify(requestBody),
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},

	createCart: (url, request) => {
		return fetch(`${url}/carts`, {
			method: 'POST',
			mode: 'cors',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				Authorization: authToken,
			},
			body: JSON.stringify(request),
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},

	createBuildAndShareCartInstance: (url, id) => {
		return fetch(`${url}/carts/build-and-share/${id}`, {
			method: 'POST',
			mode: 'cors',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				Authorization: authToken,
			},
		})
			.then((res) => {
				if (!res.ok) throw new Error('Build and share cart response was not OK');
				else return res.json();
			})
			.catch((err) => {
				console.error(err);
			});
	},

	localeRedirection: (url, referer) => {
		return fetch(`${url}/locale/redirection?referer=${encodeURIComponent(referer)}`, {
			method: 'GET',
			mode: 'cors',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				Authorization: authToken || 'anonymous',
			},
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},

	getPaymentMethods: (url, zone) => {
		return fetch(`${url}/payment-services/payment-method?zone=${zone}`, {
			method: 'GET',
			mode: 'cors',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				Authorization: authToken,
			},
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},
	getUserPayment: (url, username) => {
		return fetch(`${url}/payment-services/user-payment?username=${username}`, {
			method: 'GET',
			mode: 'cors',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				Authorization: authToken,
			},
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},
	updateCartZone: (url, cartId, zone) => {
		return fetch(`${url}/carts/${cartId}/update-zone/${zone}`, {
			method: 'PUT',
			mode: 'cors',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				Authorization: authToken,
			},
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},
	localeRedirectionv2: (url, referer, redirect_uri) => {
		return fetch(
			`${url}/locale/v2/redirection?referer=${encodeURIComponent(referer)}&redirect_uri=${redirect_uri ? encodeURIComponent(redirect_uri) : ''}`,
			{
				method: 'GET',
				mode: 'cors',
				credentials: 'include',
				headers: {
					'Content-Type': 'application/json',
					Authorization: authToken || 'anonymous',
				},
			}
		)
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},
	getGeoBlockingContent: (url) => {
		return fetch(url, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},

	validateRenewalConfig: (url, request) => {
		return fetch(`${url}/renewal-services/config/validate`, {
			method: 'POST',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(request),
		})
			.then((res) => {
				if (!res.ok) throw new Error('error');
				else return res.json();
			})
			.then((result) => result);
	},
};

export default DataService;
